import { IRuleFilter, IRuleFilterState } from '../RuleFilter.interface';

export const isRuleFilterActive = <T extends string, >(filter: IRuleFilter<T>) =>
  filter
  && Object.values<IRuleFilterState>(filter)
    .some(({ isActive }) => isActive);
